export const parseEnumLabel = (name: string) => {
    if (!name || typeof name !== 'string') return ''
    const label = name.replace(/__/g, '-').replace(/_/g, ' ')
    return label
}
